import React from 'react';
import ReactDOM from 'react-dom/client';
// @ts-ignore: Cannot find module or type declarations for side-effect import of './index.css'.
import './index.css';
import App from './App';
import { validateEnv } from './config/validateEnv';
import * as Sentry from '@sentry/react';
import pkg from '../package.json';

const container = document.getElementById('root');
if (!container) {
   throw new Error('Root element #root not found');
}

Sentry.init({
   dsn: 'https://513f7a71c80b2d2ceb4aa02470c67b5e@o4509802695622656.ingest.us.sentry.io/4511405467500544',
   // Setting this option to true will send default PII data to Sentry.
   // For example, automatic IP address collection on events
   sendDefaultPii: true,
});

validateEnv();

const apiBase = process.env.REACT_APP_API_BASE ?? '';
const environment = apiBase.includes('localhost') || apiBase.includes('127.0.0.1')
   ? 'local'
   : process.env.REACT_APP_FIREBASE_PROJECT_ID ?? 'unknown';

console.log('[Quill Studio]', {
   version: pkg.version,
   environment,
   functionsUrl: apiBase,
   nodeEnv: process.env.NODE_ENV,
});

const root = ReactDOM.createRoot(container);
root.render(
   <React.StrictMode>
      <App />
   </React.StrictMode>,
);
